// extracted by mini-css-extract-plugin
export default {"NoneDeco":"ProjectPage_NoneDeco__sMAa3","DescriptionContainer":"ProjectPage_DescriptionContainer__N-T5c"};